import QWLogo from 'assets/images/poweredBy_logo.png'

import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import config from 'config';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { getResultAnswers } from 'store/player/playerAsync';
import { selectResult } from 'store/player/playerSelectors';
import QuizTypes from 'types/QuizTypes';
import IQuestion from 'models/Question';
// Components
import LiveAppBar from 'components/LiveAppBar';
import AppLoader from 'components/AppLoader';
import QuestionItem from './QuestionItem';
import { QRCodeCanvas } from "qrcode.react";
// i18next
import i18n from 'i18n'

let interval: any;

const LiveResultsPage:FC = () => {
  const { slug } = useParams<{ slug:string }>();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLargeScreen, setIsLargeScreen] = useState(window.matchMedia("(min-width: 640px)").matches);

  const mediaHandler = (e:any) => setIsLargeScreen(e.matches);

  useEffect(() => {
    window.matchMedia("(min-width: 640px)").addEventListener('change', mediaHandler);

    return () => {
      window.matchMedia("(min-width: 640px)").removeEventListener('change', mediaHandler);
    }
  }, []);

  const result:any = useAppSelector(selectResult);
  const quiz:any = result?.quiz || null;
  const [loading, setLoading] = useState<boolean>(false);

  const fetchResult = (isTimer: boolean) => {
    dispatch(getResultAnswers({ quizName: slug })).unwrap()
    .catch(() => {
      if (!isTimer) {
        navigate('/404-not-found');
      }
    })
    .finally(() => setLoading(false));
  }

  useEffect(() => {
    setLoading(true);
    fetchResult(false);

    interval = setInterval(() => { fetchResult(true) }, 10000);

    const rootDiv = document.getElementById('root');
    rootDiv?.classList.add('liveLeaderboardMode');

    return () => {
      clearInterval(interval);
      rootDiv?.classList.remove('liveLeaderboardMode');
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!quiz) return;
    if (![QuizTypes.Poll].includes(quiz.type)) navigate('/404-not-found');
    i18n.changeLanguage(quiz.language || 'en');
    // eslint-disable-next-line
  }, [quiz]);

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;
  const bgImageUrl = quiz ? quiz.publicLeaderboard.wallpaperImage : '';
  
  if (loading || !result) return <AppLoader />;
  return (
    <div
      className="h-full overflow-scroll px-4 py-2 bg-cover bg-center bg-black sm:px-8 sm:py-4 xl:bg-right-top"
      style={{ backgroundImage: `url(${bgImageUrl})` }}
    >
      <LiveAppBar isLargeScreen={isLargeScreen} />
      <div className="mb-4 py-12 flex justify-between flex-wrap gap-8">
        {quiz.questions.map((question: IQuestion) => (
          <QuestionItem
            key={question.ref}
            question={question}
            isLargeScreen={isLargeScreen}
          />
        ))}
      </div>
      {quiz && quiz.publicLeaderboard.quizQRCodeEnabled && (
        <div className="flex flex-col gap-2 p-2 bg-white rounded-xl w-max xl:p-4" style={{ width: '100% !important' }}>
          <h2 className="text-xs font-bold text-center text-wrap sm:text-xl">{quiz?.publicLeaderboard.quizQRCodeTitle}</h2>
          <QRCodeCanvas
            value={qrCodeLink}
            level="H"
            size={isLargeScreen ? 200 : 128}
            imageSettings={{
              src: !quiz?.whiteLabeling ? QWLogo : '',
              width: isLargeScreen ? 80 : 50,
              height: isLargeScreen ? 25 : 20,
              excavate: true
            }}
          />
        </div>
      )}
    </div>
  );
}

export default LiveResultsPage;
